import React, { Component } from 'react';

class Logout extends Component {
  render() {
    return (
      <div>
        <div className="usa-alert usa-alert-warning">
          <div className="usa-alert-body">
            <h3 className="usa-alert-heading">Logging Out</h3>
            <p className="usa-alert-text">
              You were logged out.  Would you like to end your HPCMP OpenID Connect session as well?
            </p>
          </div>
        </div>
        <button onClick={this.props.onRPOnly}>No Thanks</button>
        <button className="usa-button-secondary" onClick={this.props.onRPAndSession}>Yes, End My Session</button>
      </div>
    );
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/Logout.jsx